import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
    BIOGRAPHIES: {
    path: `${baseRoutes.userBaseRoutes}biographies`,
  },
};

export default accessRoute;
